import ScenariosList from "../../components/Admins/Scenarios/ScenariosList";

export const ScenariosListPage = ()=>{
    return (
        <ScenariosList/>
    );
}
